export default __webpack_public_path__ + "static/media/banner-3.c18ced96.jpg";